import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaInfoCircle } from 'react-icons/fa';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Flex, Heading, IconButton, Tooltip, useThemedValueSwitch } from '@tq/ui-components';

import { useNotesInfoText } from 'components';
import { useCanAddNote } from 'hooks';
import { Consultation } from 'types';

type NotesHeadingProps = {
  consultation?: Consultation;
};
export const NotesHeading: React.FC<NotesHeadingProps> = ({ consultation }) => {
  const { t } = useTranslation('notes');
  const canAddNote = useCanAddNote(consultation);
  const notesInfoText = useNotesInfoText();
  const { tvs } = useThemedValueSwitch();

  return (
    <>
      {canAddNote ? (
        <Flex gridGap={2} alignItems='center' cursor='pointer'>
          <Heading mr='0.25rem' size='md'>
            {t('notes', 'Notes')}
          </Heading>
          <Tooltip
            label={notesInfoText}
            hasArrow
            placement='right'
            background={COLOURS.blue[100]}
            width='330px'
            p={4}
            fontSize='14px'
            borderRadius={4}
            border={`2px solid ${COLOURS.blue[600]}`}
          >
            <IconButton
              height='1.25rem'
              width='1.25rem'
              aria-label={t('notes_tooltip', 'Notes tooltip')}
              icon={
                <FaInfoCircle
                  color={tvs({ tq: 'blue.275' }, COLOURS.blue[600])}
                  fontSize='1.25rem'
                />
              }
            ></IconButton>
          </Tooltip>
        </Flex>
      ) : (
        <Heading size='md'>{t('notes', 'Notes')}</Heading>
      )}
    </>
  );
};
